import axios from "axios";

export const addGoalComment = async (
  user_id,
  goal_id,
  comment_text,
  token,
  parent_id = null,
) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL_USER}/addComments`,
      {
        user_id,
        goal_id,
        comment_text,
        parent_id,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const addLeagueGoalComment = async (
  user_id,
  goal_id,
  comment_text,
  token,
  parent_id,
) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL_USER}/leagues/postComment`,
      {
        user_id,
        goal_id,
        comment_text,
        parent_id,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};
export const addClubGoalComment = async (
  user_id,
  goal_id,
  comment_text,
  token,
  parent_id,
) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL_USER}/clubs/postComment`,
      {
        user_id,
        goal_id,
        comment_text,
        parent_id,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};
